export default function loadFonts() {
  require('@fontsource/roboto/400.css');
  require('@fontsource/roboto/500.css');
  require('@fontsource/roboto/700.css');
  require('@fontsource/montserrat/400.css');
  require('@fontsource/montserrat/700.css');
  require('@fontsource/montserrat/800.css');
  require('@fontsource/courier-prime/400.css');
}
